import React from 'react';
import { Landmark, Building2, CheckCircle2, Users, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { coveragePaths, businessInfo } from '../mock/data';

const iconMap = { Landmark, Building2 };

const CoveragePaths = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${businessInfo.phoneTel}`;
  };

  return (
    <section className="py-20 bg-[#152238] text-white" data-testid="coverage-paths-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Two Paths to Coverage
          </h2>
          <p className="text-xl text-[#A8B5C8] max-w-3xl mx-auto">
            We specialize equally in ACA marketplace plans and private health insurance. Each works differently — we'll help you find out which path fits you best.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {coveragePaths.map((path) => {
            const Icon = iconMap[path.icon];
            return (
              <div
                key={path.id}
                className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 flex flex-col hover:bg-white/15 transition-colors duration-300"
                data-testid={`coverage-path-${path.id}`}
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 rounded-xl bg-white text-[#152238] flex items-center justify-center flex-shrink-0">
                    <Icon className="w-7 h-7" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-widest text-[#A8B5C8] font-semibold">{path.label}</div>
                    <h3 className="text-2xl md:text-3xl font-bold">{path.title}</h3>
                  </div>
                </div>

                <p className="text-[#A8B5C8] leading-relaxed mb-6">{path.subtitle}</p>

                <div className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl p-4 mb-6">
                  <Users className="w-5 h-5 text-[#A8B5C8] flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-white/90">
                    <span className="font-semibold text-white">Best for: </span>{path.audience}
                  </p>
                </div>

                <ul className="space-y-3 flex-1">
                  {path.benefits.map((benefit) => (
                    <li key={benefit} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-[#A8B5C8] flex-shrink-0 mt-0.5" />
                      <span className="text-white/90">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-[#A8B5C8] mb-5">Not sure which path is right for you? We compare both — at no cost.</p>
          <Button
            size="lg"
            onClick={handleCallClick}
            data-testid="coverage-paths-call-btn"
            className="bg-white text-[#3B5275] hover:bg-blue-50 font-semibold text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
          >
            <Phone className="w-5 h-5 mr-2" />
            Compare My Options
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CoveragePaths;
